
export const CircleIndicator = ({ active, margin = "" }) => {
  return active && (<div className={`text-center ${margin}`}>
    <div className="spinner-grow" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>);
};